<div class="modal-header">
  <h4 class="modal-title">Pièces jointes</h4>
  <button (click)="closeModal()" aria-label="Close" class="btn-close" type="button"></button>
</div>

<div class="modal-body" *ngIf="pieceJointes | async as listePj">
  <div class="error-message" *ngIf="errorMessage()">
    {{ errorMessage() }}
  </div>

  <div class="documents-list" *ngIf="listePj.length > 0">
    <div class="document-item" *ngFor="let pj of listePj">
      <div class="document-info" (click)="onOpenDocument(pj)">
        <span>{{ pj.titre }}</span>
      </div>
      <button class="delete-btn" (click)="onDeleteDocument(pj)" [disabled]="(loading | async)">
        <i class="bi bi-trash-fill"></i>
      </button>
    </div>
  </div>

  <div class="empty-state" *ngIf="listePj.length === 0">
    Aucune pièce jointe
  </div>

  <input
    #fileInput
    type="file"
    (change)="onFileSelected($event)"
    [accept]="acceptedFormats"
    style="display: none"
    [disabled]="(loading | async)"
  />

  <button class="add-btn" (click)="fileInput.click()" [disabled]="(loading | async)">
    + Ajouter une pièce jointe
  </button>

  <div *ngIf="(loading | async)" class="d-flex justify-content-center mt-3">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
